import { IDiagnosticState } from './types'

const initialState: IDiagnosticState = {
  loading: false,
  error: false,
  status: 'INITIALIZED',
}

export default initialState
